module.exports = __webpack_public_path__ + "img/pic_2_1.8123068f.jpg";